import { AfterViewInit, Directive, Host, HostListener, Input, Optional, Self, ViewContainerRef, effect } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CheckBoxItem } from '../components/inputs/checkbox-button/checkbox-button.component';
import { CheckBoxMultipleItem } from '../components/inputs/checkbox-multiple-buttons/checkbox-multiple-buttons.component';


// export type

@Directive({
  selector: '[field]'
})
export class FormFieldDirective  {

  // @Input({required: true}) inputComponent!: AbstractFormFieldDirective<FormFieldsValues>
  @Input({required: true}) name!: string


  constructor(private viewContainerRef: ViewContainerRef) {
    // const componentInstance = this.viewContainerRef['_view'].component;
    // console.log('Host component:', componentInstance);

  }

  // eff = effect( () => {
  //   console.log(this.inputComponent.fieldModel())
  // })

  // @HostListener('click', ["$event"])
  // onClick(btn: any) {
  //   // console.log(this.inputComponent.fieldModel )
  // }

  // ngAfterViewInit() {
  //   this.inputComponent.fieldModel.subscribe( (value) => {
  //     // console.log({
  //     //   [this.name] : x
  //     // });
  //     console.log({[this.name] : this.viewContainerRef})
  //     this.model.next({
  //       name: this.name,
  //       value
  //     })
  //   })
  // }

}
